const initialState = {
  walletTransaction: [],
  otherTransaction: [],
  totalWalletAmount: {},
  walletMoreData: true,
  walletLastDocument: "",
  otherMoreData: true,
  otherLastDocument: "",
  ContractRequests: [],
  SignedContracts: [],
  Contract: null,
  approvedContracts: [],
  contractLastDocument: null,
  contractHasMore: true,
  loadingContracts: false,
  loadingSignedContracts: false,
  loadingApprovedContracts: false,
};

const contractRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONTRACT_REQUESTS_LOADING":
      return { ...state, loadingContracts: action.payload };
    case "SIGNED_CONTRACTS_LOADING":
      return { ...state, loadingSignedContracts: action.payload };
    case "APPROVED_CONTRACTS_LOADING":
      return { ...state, loadingApprovedContracts: action.payload };

    case "GET-WALLET-TRANSACTION":
      return {
        ...state,
        walletTransaction: [
          ...state.walletTransaction,
          ...action.payload.temp_data,
        ],
        walletMoreData: action.payload.hasMoreDocument,
        walletLastDocument: action.payload.lastDocument,
      };
    case "GET-OTHER-TRANSACTION":
      return {
        ...state,
        otherTransaction: [
          ...state.otherTransaction,
          ...action.payload.temp_data,
        ],
        otherMoreData: action.payload.hasMoreDocument,
        otherLastDocument: action.payload.lastDocument,
      };
    case "GET-WALLET-TRANSACTION-EMPTY":
      return {
        ...state,
        walletTransaction: action.payload.temp_data,
        moreData: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET-OTHER-TRANSACTION-EMPTY":
      return {
        ...state,
        otherTransaction: action.payload.temp_data,
        otherMoreData: action.payload.hasMoreDocument,
        otherLastDocument: action.payload.lastDocument,
      };
    case "GET-TOTAL-AMOUNT":
      return {
        ...state,
        totalWalletAmount: action.payload,
      };
    case "GET_APPROVED_CONTRACTS":
      return {
        ...state,
        approvedContracts: action.payload.data,
        contractLastDocument: action.payload.lastDocument,
        contractHasMore: action.payload.hasMore,
      };
    case "MORE_GET_APPROVED_CONTRACTS":
      return {
        ...state,
        approvedContracts: [...state.approvedContracts, ...action.payload.data],
        contractLastDocument: action.payload.lastDocument,
        contractHasMore: action.payload.hasMore,
      };
    case "GETAllContractRequests":
      return {
        ...state,
        ContractRequests: action.payload,
      };
    case "GETAllSignedContracts":
      return {
        ...state,
        SignedContracts: action.payload,
      };
    case "GETContractByID":
      return {
        ...state,
        Contract: action.payload,
      };
    default:
      return state;
  }
};
export default contractRequestsReducer;
